import classNames from 'classnames'
import React from 'react'

import useThemeSettings from 'customizer/theme/useThemeSettings'
import CircleInfo from 'icons/bold/01-Interface Essential/14-Alerts/information-circle.svg'
import ArrowUp from 'icons/bold/52-Arrows-Diagrams/01-Arrows/arrow-up-1.svg'

import './DescriptionButton.scss'

interface DescriptionButtonProps {
  style?: React.CSSProperties
  className?: string
  isVisible: boolean
  onClick: () => void
}

const DescriptionButton = ({ style, className, isVisible, onClick }: DescriptionButtonProps) => {
  const descriptionStyle = useThemeSettings('description')

  if (isVisible) return null

  return (
    <button
      className={classNames('description-button', className)}
      onClick={e => {
        e.stopPropagation()
        onClick()
      }}
      style={{
        backgroundColor: descriptionStyle.buttonBackgroundColor,
        borderColor: descriptionStyle.buttonBorderColor,
        borderRadius: descriptionStyle.buttonRounding,
        ...style,
      }}
    >
      <CircleInfo className="info-icon" fill={descriptionStyle.iconsColor} />
      <ArrowUp className="arrow-icon" fill={descriptionStyle.iconsColor} />
    </button>
  )
}

export default DescriptionButton
